export class DocumentoPac {
  id: number;
  numeroPac: number;
  numeroPacStr: string;
  propostaNumero: string;
  propostaAno: number;
	programaId: number;
	programaNome: string;
	linhaId: number;
	linhaNome: string;
  dataProtocolo : Date;
  nomeInstituicaoCredenciada : string;
  codigoFnameCredenciada : number;
  situacaoNomeInterno: string;
  situacaoNomeExterno: string;
  tipoSistematica: string;
  valorFinanciadoFname: number;

  valorInstituicaoCredenciada : number;
  valorParticipacaoFinaciado : number;
  mesesCarencia : number;
  mesesAmortizacao : number;
  periodicidadeCarencia :  string;
  periodicidadeAmortizacao : string;
  idModalidadeDeJuros : number;
  taxaGarantiaFgi : number;
  classificacaoRisco : string;
  dataContratacao : Date;
  dataUltimaCarencia : Date;
  garantias: string;
  numeroCe: string;
  anoCe: string;

  // Campos relativos a comprador
  compradorId: number;
  compradorCnpjCpf: string;
  compradorNome: string;
  compradorCnae: string;
  compradorCnaeNome: string;
  compradorCapitalSocialId: number;
  compradorCapitalSocialNome: string;
  compradorPorteId: number;
  compradorPorteNome: string;
  compradorIndAtividadeDecreto: boolean;
  compradorRobTipo: string;
  compradorRobValor: number;
  compradorRobData: Date;
  compradorDataDeConstituicao: Date;
  compradorNaturezaDaEmpresa: string;
  compradorEnderecoSede: string;
  compradorBairroSede: string;
  compradorMunicipioSede: string;
  compradorUfSede: string;
  compradorCepSede: string;
  compradorEnderecoCorrespondencia: string;
  compradorBairroCorrespondencia: string;
  compradorMunicipioCorrespondencia: string;
  compradorUfCorrespondencia: string;
  compradorCepCorrespondencia: string;
  grupoCnpjLider: string;
  grupoRobTipo: string;
  grupoRobValor: number;
  grupoRobData: Date;


  municipioInstalId: number;
  municipioInstalNome: string;
  municipioInstalUf: string;
  investimentoCnpj: string;
  investimentoCnae: string;
  investimentoCnaeNome: string;
  condicaoOperacional: string;

  dataAprovacao: Date;

  //CONDICOES DA OPERACAO
  unidadeRemuneracaoBndes: string;
  taxaRemuneracaoBndes: number;
  taxaRemuneracaoBasicaBndes: number;
  taxaFatorAlteracao: number;
  taxaIntermedicao: number;
  taxaCustoFinanceiroAdicional: number;
  idCusto: number;
  nomeUnidadeMonetariaCobranca: string;
  taxaDeRemuneracaoAgente: number;

  public get grupoRobTipoNome() {
    return this.nomeTipo(this.grupoRobTipo);
  }

  public get compradorRobTipoNome() {
    return this.nomeTipo(this.compradorRobTipo);
  }

  private nomeTipo(tipo) {
    if (tipo == 'E') {
      return 'Efetivo'
    } else if (tipo == 'P') {
      return 'Previsto'
    } else if (tipo == null) {
      return 'Não Informado'
    } else {
      return tipo;
    }
  }

  public get compradorCnaeIdNome() {
    return (this.compradorCnae) ? this.compradorCnae + ' - ' + this.compradorCnaeNome : null;
  }

  public get investimentoCnaeIdNome() {
    return (this.investimentoCnae) ? this.investimentoCnae + ' - ' + this.investimentoCnaeNome : null;
  }

  public get municipioInstalNomeUf() {
    return (this.municipioInstalId) ? this.municipioInstalNome + '/' + this.municipioInstalUf : null;
  }
}
